import { render, staticRenderFns } from "./LeftTreeBox.vue?vue&type=template&id=2f88f4c9&scoped=true"
import script from "./LeftTreeBox.vue?vue&type=script&lang=js"
export * from "./LeftTreeBox.vue?vue&type=script&lang=js"
import style0 from "./LeftTreeBox.vue?vue&type=style&index=0&id=2f88f4c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88f4c9",
  null
  
)

export default component.exports